import { render, staticRenderFns } from "./FormTemplatesList.vue?vue&type=template&id=54763676&"
import script from "./FormTemplatesList.vue?vue&type=script&lang=js&"
export * from "./FormTemplatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports